import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import NavigationIcon from "@material-ui/icons/HowToVoteOutlined";

const styles = (theme) => ({
	fab: {
		margin: "25px 0",
		borderRadius: 0,
		width: "auto",
		background: "#1d99b4",
		"&:hover": {
			background: "#1a6d80"
		}
	},
	label: {
		fontSize: "35px",
		letterSpacing: "2px",
		color: "red"
	},
	extendedIcon: {
		margin: "15px 0"
	}
});

function FloatingActionButtons(props) {
	const { classes } = props;
	return (
		<React.Fragment>
			<Fab
				onClick={props.onClick}
				variant="extended"
				color="secondary"
				aria-label="Edit"
				className={classes.fab}
				type={props.type || ""}>
				<NavigationIcon
					onClick={props.onClick}
					className={classes.extendedIcon + " add-btn"}
					style={{ margin: "0 10px" }}
				/>
				{props.text}
			</Fab>
		</React.Fragment>
	);
}

FloatingActionButtons.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FloatingActionButtons);
